<template>
    <CodiceFeanorView tool-module="secret" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
